import type { BlockSectionBg } from "./common/types";

export type GalleryTheme = {
  headline: string;
  bodyText: string;
  tagVariant: "default" | "onTinted";
  navButton: string;
  paginationDotActive: string;
  paginationDotInactive: string;
};

/** Figma block_carousel — nav and pagination contrast per section background. */
const galleryThemeMap: Record<BlockSectionBg, GalleryTheme> = {
  light: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    navButton: "bg-foreground text-background hover:opacity-80",
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
  },
  default: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    navButton: "bg-foreground text-background hover:opacity-80",
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
  },
  muted: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    navButton: "bg-foreground text-background hover:opacity-80",
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
  },
  dark: {
    headline: "text-secondary-foreground",
    bodyText: "text-header-top-fg",
    tagVariant: "onTinted",
    navButton: "bg-background text-foreground hover:bg-muted",
    paginationDotActive: "bg-secondary-foreground",
    paginationDotInactive: "border-secondary-foreground/40 bg-transparent",
  },
  red: {
    headline: "text-primary-foreground",
    bodyText: "text-header-top-fg",
    tagVariant: "onTinted",
    navButton: "bg-background text-foreground hover:bg-muted",
    paginationDotActive: "bg-primary-foreground",
    paginationDotInactive: "border-primary-foreground/40 bg-transparent",
  },
};

export function resolveGalleryTheme(sectionBg: BlockSectionBg): GalleryTheme {
  return galleryThemeMap[sectionBg] ?? galleryThemeMap.light;
}
